export class Email {
    constructor(
        public subject: string,
        public fromName: string,
        public fromEmail: string,
        public toEmail: string,
        public body: string
    ) { }
}